import type { SpaceAccountNoteModelData } from "@/store/recent-items/types";

interface BuildMarkNoteViewedModelDataParams {
  existingModelData: SpaceAccountNoteModelData | undefined;
  isRunningRelevantNoteExtractionPipeline: boolean | undefined;
  lastRelevantNoteExtractionCompletedAt: string | null | undefined;
  lastRelevantNoteExtractionNoteModelVersion: number | null | undefined;
  lastRelevantNoteExtractionStartedAt: string | null | undefined;
  noteId: string;
  spaceAccountId: string;
  viewedAt: string;
}

/**
 * Builds the optimistic SpaceAccountNote model data for a note-view event.
 *
 * Marking a note viewed owns the recents/extraction fields, so it must preserve
 * unrelated model data such as reminder shills while updating those fields.
 */
export function buildMarkNoteViewedModelData({
  existingModelData,
  isRunningRelevantNoteExtractionPipeline,
  lastRelevantNoteExtractionCompletedAt,
  lastRelevantNoteExtractionNoteModelVersion,
  lastRelevantNoteExtractionStartedAt,
  noteId,
  spaceAccountId,
  viewedAt,
}: BuildMarkNoteViewedModelDataParams): SpaceAccountNoteModelData {
  return {
    ...existingModelData,
    space_account_id: spaceAccountId,
    note_id: noteId,
    last_viewed_at: viewedAt,
    last_relevant_note_extraction_started_at: lastRelevantNoteExtractionStartedAt ?? null,
    last_relevant_note_extraction_completed_at: lastRelevantNoteExtractionCompletedAt ?? null,
    is_running_relevant_notes_extraction_pipeline: isRunningRelevantNoteExtractionPipeline ?? false,
    last_relevant_note_extraction_note_model_version:
      lastRelevantNoteExtractionNoteModelVersion ?? null,
    shared_with_me_at: existingModelData?.shared_with_me_at ?? null,
    shared_with_me_by_space_account_id:
      existingModelData?.shared_with_me_by_space_account_id ?? null,
    suggestion_data: existingModelData?.suggestion_data ?? null,
    reminder_shill: existingModelData?.reminder_shill ?? null,
  } as SpaceAccountNoteModelData;
}
